import { Text, TextProps } from '@chakra-ui/react';

type TitleTextProps = TextProps & {
  text: string;
};

export const TitleText = ({ text, ...rest }: TitleTextProps): JSX.Element => {
  return <Text {...rest}>{text}</Text>;
};

TitleText.defaultProps = {
  fontFamily: 'Raleway',
  fontWeight: 600,
  fontSize: '24px',
  lineHeight: '28px',
  letterSpacing: '5%',
  color: 'custom.levoBlue',
  textAlign: 'center',
};

export default TitleText;
